import { Check, X } from "lucide-react";
import { WHIRLYBIRD } from "./data";
import { Reveal, scrollToId } from "./motion";

export const WhirlybirdCompare = () => {
  return (
    <section id="whirlybirds" data-testid="whirlybird-compare" className="relative py-24 lg:py-36 bg-[#050505] border-t border-[#1c1c1c]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="font-mono-eng text-xs tracking-[0.2em] uppercase text-[#fcc41b] mb-5">{WHIRLYBIRD.overline}</p>
          <h2 className="font-display font-bold text-4xl sm:text-5xl text-white tracking-tight max-w-3xl">{WHIRLYBIRD.title}</h2>
          <p className="text-zinc-400 text-base leading-relaxed max-w-3xl mt-6">{WHIRLYBIRD.subtitle}</p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-14 overflow-x-auto rounded-3xl border border-[#262626]" data-testid="whirlybird-table">
            <table className="w-full text-left border-collapse min-w-[640px]">
              <thead>
                <tr className="bg-[#0d0d0d]">
                  <th className="py-5 px-6 font-display font-semibold text-sm text-zinc-500 uppercase tracking-wider">Feature</th>
                  <th className="py-5 px-6 font-display font-semibold text-sm text-zinc-400 uppercase tracking-wider">Whirlybird</th>
                  <th className="py-5 px-6 font-display font-semibold text-sm text-[#fcc41b] uppercase tracking-wider">SolarArk</th>
                </tr>
              </thead>
              <tbody>
                {WHIRLYBIRD.rows.map((r, i) => (
                  <tr key={r.feature} data-testid={`whirlybird-row-${i}`} className="border-t border-[#1c1c1c]">
                    <td className="py-5 px-6 text-white font-medium align-top">{r.feature}</td>
                    <td className="py-5 px-6 text-zinc-400 align-top">
                      <span className="flex items-start gap-2.5">
                        <X size={17} className="text-zinc-600 shrink-0 mt-0.5" />
                        <span>{r.whirlybird}</span>
                      </span>
                    </td>
                    <td className="py-5 px-6 text-zinc-200 align-top">
                      <span className="flex items-start gap-2.5">
                        <Check size={17} className="text-[#fcc41b] shrink-0 mt-0.5" />
                        <span>{r.solarark}</span>
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              onClick={() => scrollToId("calculator")}
              data-testid="whirlybird-calculator-cta"
              className="inline-flex items-center gap-2 rounded-full bg-[#fcc41b] text-black font-display font-semibold px-7 py-3.5 hover:bg-[#ffd245] transition-colors duration-300"
            >
              See how many whirlybirds one SolarArk replaces
            </button>
            <button
              onClick={() => scrollToId("quote")}
              data-testid="whirlybird-quote-cta"
              className="inline-flex items-center gap-2 rounded-full border border-[#fcc41b]/50 text-[#fcc41b] font-display font-semibold px-7 py-3.5 hover:bg-[#fcc41b] hover:text-black transition-colors duration-300"
            >
              Upgrade from whirlybirds
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
